module.exports = __webpack_public_path__ + "img/Oogbescherming_verplicht.73dd57af.jpg";